module.exports = __webpack_public_path__ + "static/media/3 05 Tulleord Falk er riktig.e79d1506.mp3";